import { render, staticRenderFns } from "./MedicoObsLista.vue?vue&type=template&id=68e7e575&"
import script from "./MedicoObsLista.vue?vue&type=script&lang=js&"
export * from "./MedicoObsLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports